import React, { Component } from 'react';
import MaterialIcon from 'material-icons-react';

export default class TreeNewTeamMobile extends Component {

    constructor(props) {
        super(props);
    }

    addNewTeam = () => {
        this.props.addNewTeam();
    }

    render() {
        return (
            <div>
                <button type="button" onClick={() => this.addNewTeam()}
                    className={`btn rounded-circle new-team-btn__mobile`}>
                    <MaterialIcon size="25px" color="white" icon="group_add" />
                </button>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Tree/TreeNewTeam/TreeNewTeamMobile.jsx